import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchAdminAuditTypes } from '@/api/(admin)/audit-types';
import type { AdminAuditType } from '@/api/(admin)/audit-types/types';
import type { AuditTypesQueryInput } from '../-types';
import { buildAuditTypesQs, toAuditTypesParams } from '../-utils/listParams';

/** Prefix for every audit-types cache entry — what a write invalidates. */
export const adminAuditTypesQueryKey = ['admin', 'audit-types'] as const;

/** Shared by the route loader and the page, so the prefetch warms what the page reads. */
export function adminAuditTypesQueryOptions(input: AuditTypesQueryInput) {
  const params = toAuditTypesParams(input);
  return queryOptions({
    queryKey: [...adminAuditTypesQueryKey, 'list', params] as const,
    queryFn: () => fetchAdminAuditTypes(buildAuditTypesQs(params)),
  });
}

export function useAdminAuditTypes(input: AuditTypesQueryInput) {
  const query = useQuery(adminAuditTypesQueryOptions(input));
  const rows: AdminAuditType[] = query.data?.data ?? [];
  return { ...query, rows, totalCount: query.data?.meta?.totalCount ?? 0 };
}
